import {
  Box,
  Divider,
  IconButton,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import { assetIcons } from "../../../constants/assets";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import GradientButton from "../gradient-button";
import Wager from "./wager";
import RacerProfile from "./racer-profile";
import BetDetails from "./bet-details";
import englishTranslations from "../../../i18n/translations/en";
import InlineSvg from "../inline-svg";
import { useUser } from "../../../context/user-context";

const SwipeableDrawerComponent = ({
  isDrawerOpen,
  setIsDrawerOpen,
  isMediumScreen,
  bets,
  racerInfo,
  wager,
  setWager,
  racerId,
  handlePlaceBet,
  betOpen,
}) => {
  const { user } = useUser();

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={isDrawerOpen}
      onClose={() => setIsDrawerOpen(false)}
      onOpen={() => setIsDrawerOpen(true)}
      sx={{
        "& .MuiDrawer-paper": {
          bgcolor: "#1A1A1A",
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          height: { sm: 860, xs: 600 },
        },
      }}
    >
      <Box
        display={"flex"}
        alignItems={"end"}
        justifyContent={"space-between"}
        onClick={() => setIsDrawerOpen(false)}
      >
        <Box display={"flex"} mt={3} alignItems={"center"} ml={3}>
          <InlineSvg sx={{ mr: 1.5, mb: -0.3 }} url={assetIcons.dice} />

          <Typography
            color={darkColors.primary}
            fontSize={fontSizes.heading3}
            fontFamily={"MontserratBold"}
            textAlign={"left"}
          >
            {englishTranslations.bet.betPanel}
          </Typography>
        </Box>
        <Box sx={{ mr: 2 }}>
          <IconButton size="small" sx={{ color: darkColors.buttonTop }}>
            {isDrawerOpen ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ p: 3, pt: 2 }}>
        <Box mt={2}>
          <BetDetails bets={bets} isMediumScreen={isMediumScreen} />
        </Box>
        {betOpen && (
          <>
            <Box mt={4}>
              <RacerProfile
                racerInfo={racerInfo}
                isMediumScreen={isMediumScreen}
                racerId={racerId}
              />
            </Box>
            <Box mt={4}>
              <Wager wager={wager} setWager={setWager} />
            </Box>
            <Divider sx={{ background: darkColors.gray, my: 2 }} />

            <Box pb={1}>
              <GradientButton
                text={englishTranslations.bet.placeBet}
                variant="contained"
                width="100%"
                fontSize={fontSizes.heading2}
                onClick={handlePlaceBet}
                disabled={wager > user.walletAmount || !wager || wager === "0"}
              />{" "}
            </Box>
          </>
        )}
      </Box>
    </SwipeableDrawer>
  );
};
export default SwipeableDrawerComponent;
